<template>
	<div class="add-item-header">
		<div class="add-item-header-top">
			<div v-if="title" class="add-item-title-wrapper">
				<div class="add-item-title">{{ title }}</div>
			</div>
			<button
				v-if="showCloseModal"
				type="button"
				class="modal-close-button"
				@click.prevent="handleClick"
			>
				<span class="screen-reader">Close Cart</span>
				<div class="icon-close">
					<div class="icon-close-inner"></div>
				</div>
			</button>
		</div>
		<div class="add-item-header-bottom">
			<div class="add-item-menu-description" v-if="description">
				{{ description }}
			</div>
			<div v-if="price">${{ price }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "AddItemHeader",
	props: {
		title: String,
		description: String,
		price: [String, Number],
		showCloseModal: { type: Boolean, default: true }
	},
	methods: {
		handleClick() {
			this.$emit("close-modal");
		}
	}
};
</script>

<style lang="scss" scoped>
.add-item-header {
	color: $black;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 100%;
}

.add-item-header-top {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	margin-bottom: 15px;
}

.add-item-title-wrapper {
	display: flex;
	align-items: center;
}

.add-item-title {
	font-size: 2.8rem;
	font-weight: 900;
}

.screen-reader {
	@include screen-reader-text;
}

.modal-close-button {
	@include transition(color);
	display: block;

	&:hover,
	&:focus {
		color: $gold;
	}
}

.icon-close {
	display: block;
	height: 33px;
	width: 33px;
	position: relative;
	color: $black;

	@media (min-width: $mobileLandscape) {
		height: 53px;
		width: 53px;
	}
}

.icon-close-inner {
	&::before,
	&::after {
		content: "";
		display: block;
		background-color: currentColor;
		width: 6px;
		height: 33px;
		position: absolute;
		top: 0;
		left: 100%;
		border-radius: 100px;

		@media (min-width: $mobileLandscape) {
			width: 6px;
			height: 53px;
			left: 50%;
		}
	}

	&::before {
		transform: translate(-50%, -3px) rotate(45deg);
	}

	&::after {
		transform: translate(-50%, -3px) rotate(-45deg);
	}
}

.add-item-header-bottom {
	font-size: 16px;
	font-weight: 400;
}

.add-item-menu-description {
	margin-bottom: 10px;
}
</style>